import { Route, Routes } from "react-router-dom";
import FooterBase from "./FooterBase";

const Footer = () => {

    return (

        <Routes>
            <Route  path='/profile' element={<FooterBase />} />
            <Route  path='/my-products' element={<FooterBase />} />
            <Route  path='/products' element={<FooterBase />} />
            <Route  path='/orders' element={<FooterBase />} />
            <Route  path='/orders/:uniqueCode' element={<FooterBase />} />
            <Route  path='/couriers' element={<FooterBase />} />
            <Route  path='/couriers/add' element={<FooterBase />} />
            <Route  path='/couriers/edit/*' element={<FooterBase />} />

            <Route  path='/trans' element={<FooterBase />} />
            <Route  path='/trans/add' element={<FooterBase />} />
            <Route  path='/accumulative' element={<FooterBase />} />
            <Route  path='/settlements' element={<FooterBase />} />
            <Route  path='/installments/factors' element={<FooterBase  />} />
            <Route  path='/authentication' element={<FooterBase  />} />
        </Routes>

    );
}

export default Footer;